<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <!-- <Wxts :wxtsList="wxtsList" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #end>
        <!-- 导出按钮 -->
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`车辆承运利润表`)">导出</el-button>
        </el-form-item>
        <!-- 查看全部车辆 -->
        <el-form-item class="viewAllBtn">
          <el-button type="primary" @click="goCarList">查看全部车辆</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
// import Wxts from '../../../components/Wxts.vue';

export default {
  mixins: [tableMixin],
  // components: { Wxts },
  data() {
    return {
      baseUrl: 'pcustom',
      getListUrl: 'carprofit',
      breadcrumb: [
        { name: "财务管理", path: '/finance/carrierProfit' },
        { name: "承运利润表", path: '/finance/carrierProfit' },
        { name: "承运车辆利润表" },
      ],
      wxtsList: [
        {
          name: '净利润=(应收运费-亏吨金额)-(应付运费-亏吨金额)-附加费用+运单补差。'
        }
      ],
      formInline: { month: '' },
      formCtrl: [
        {
          ...this.ctrls.month,
        },
        {
          ...this.ctrls.license,
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 100 },
        { keyName: "driver", label: "司机姓名" },
        { keyName: "company", label: "承运公司", minwidth: 150 },
        { keyName: "ys_freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "yf_freight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', width: 110 },
        { keyName: "additional_fees", label: "附加费用", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "compen", label: "运单补差", align: 'right', className: 'pr30', width: 110 },
        { keyName: "profit", label: "净利润", align: 'right', className: 'pr30', width: 110 },
      ],
      getTotalProperty: [
        'ys_freight',
        'yf_freight',
        'kuitotal',
        'additional_fees',
        'compen',
        'profit',
      ],
      btns: [
        {
          title: '运单列表',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ license }) => {
            const o = {}
            const { month } = this.formInline
            if (month) {
              o['predict_loading_date'] = this.getMonthRange(month)
            }
            const path = '/finance/carrierProfitOrder'
            this.setStore({
              ['formInline' + path]: o,
            })
            this.$router.push({
              path: `/finance/carrierProfitOrder`,
              query: {
                license,
              }
            });
          },
        },
      ],
      baseParams: ['month', 'p_id'],
    };
  },
  methods: {
    goCarList() {
      let path = `/finance/carrierProfitAllCarList`
      this.$router.push({
        path,
      })
    },
  },
  mounted() {
    this.setQueryParams();
    if (this.formInline.month) {
      this.MONTH = this.formInline.month
    } else {
      this.MONTH = this.CURR_MONTH
      this.$set(this.formInline, 'month', this.CURR_MONTH)
    }
    this.$nextTick(this.getList);
  },
};
</script>

<style lang="less" scoped>
/deep/ .retrieval {
  .viewAllBtn {
    .el-button {
      width: 100px;
    }
  }
}
</style>